import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Button, ButtonGroup, Dropdown, FormControl } from "react-bootstrap";

import "./UnityConsole.sass";

export default class UnityConsole extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commandHistory: []
    };

    this.historyId = 0;

    this.player = {
      SendMessage: (...params) => {
        this.setState({
          commandHistory: [
            {
              id: ++this.historyId,
              timestamp: new Date(),
              data: params
            },
            ...this.state.commandHistory
          ]
        });
      }
    };

    // attach to window so unityCommander can access directly as if it were
    // the webgl unity player instance
    window._unityPlayer = this.player;
  }

  clearHistory = () => {
    this.setState({
      commandHistory: []
    });
  };

  sendUnityCommand = () => {
    this.props.addUnityCommand(this.commandInput.value);
    this.commandInput.value = "";
  };

  componentDidMount() {
    this.props.setInitialized();
  }

  componentWillUnmount() {
    this.player = null;
  }

  formatTimestamp = ts => {
    let hours = ts.getHours();
    let minutes = ts.getMinutes();
    let seconds = ts.getSeconds();

    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return `${hours}:${minutes}:${seconds}`;
  };

  render() {
    return (
      <div
        id="unity-player"
        className="d-flex flex-grow-1 flex-column unity-player unity-console"
      >
        <div className="d-flex flex-grow-1">
          <ol>
            {this.state.commandHistory.map(cmd => (
              <li key={"cmd-" + cmd.id}>
                <span className="ts">
                  {this.formatTimestamp(cmd.timestamp)} >{" "}
                </span>
                {cmd.data.map(data => (
                  <span className="cmd" key={data}>
                    {data}
                  </span>
                ))}
              </li>
            ))}
          </ol>
        </div>
        <div className="d-flex p-2">
          <FormControl
            type="text"
            ref={elem => (this.commandInput = elem)}
            placeholder="Enter custom unity command - Press Enter to send"
            onKeyDown={e => {
              if (e.key === "Enter") {
                this.sendUnityCommand();
              }
            }}
          />
          <Dropdown as={ButtonGroup} drop="up" className="ml-2">
            <Button size="sm" variant="secondary" onClick={this.clearHistory}>
              Clear
            </Button>
            <Dropdown.Toggle split variant="secondary" id="dropdown-split-basic" />
            <Dropdown.Menu>
              <Dropdown.Item onClick={this.props.finishSimulation}>
                Finish Simulation
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  }
}
UnityConsole.defaultProps = {
  webPath: "",
  loading: true,
  loadingProgress: 0,
  loadingMessage: ""
};
UnityConsole.propTypes = {
  webPath: PropTypes.string,
  loading: PropTypes.bool,
  loadingProgress: PropTypes.number,
  loadingMessage: PropTypes.string,
  setInitialized: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  setLoadingProgress: PropTypes.func.isRequired
};
